import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@app/store';
import { fetchSectors, deleteSector } from './SectorSlice';
import DataTable from '@components/ui/DataTable';
import type { Column } from '@components/ui/DataTable';
import { SectorOutputDTO } from './types';
import { LoadingSkeleton } from '@components/ui/LoadingSkeleton';
import { ErrorDisplay } from '@components/ui/ErrorDisplay';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { setLoading } from '../phaseForm';

const SectorList = () => {
  console.log('🔄 Renderizando SectorList');
  
  const dispatch = useDispatch<AppDispatch>();
  const { items, loading, error } = useSelector((state: RootState) => {
    console.log('🔍 Selector executando, loading:', state.sector.loading);
    return state.sector;
  });
  
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [filters, setFilters] = useState<Record<string, string>>({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const isLoadingRef = useRef(false);
  const initialLoadDoneRef = useRef(false);

  const loadData = useCallback(async (currentFilters: Record<string, string>) => {
    // Avoid simultaneous calls
    if (isLoadingRef.current) {
      console.log('🚫 Requisição em andamento, ignorando nova chamada');
      return;
    }

    // Avoid calls after initial load
    // if (initialLoadDoneRef.current && Object.keys(currentFilters).length === 0) {
    //   console.log('🚫 Ignorando chamada sem filtros após carregamento inicial');
    //   return;
    // }

    console.log('📡 Iniciando requisição fetchSectors');
    isLoadingRef.current = true;
    
    try {
      await dispatch(fetchSectors(currentFilters));
      initialLoadDoneRef.current = true;
    } finally {
      isLoadingRef.current = false;
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    console.log('🔄 useEffect - Carregando dados iniciais');
    loadData(filters);
    setIsInitialLoad(false);
  }, [loadData, filters]);

  
  const handleFilterChange = (newFilters: Record<string, string>) => {
    console.log('🔍 Filtros alterados:', newFilters);
    setFilters(newFilters);
  };

  const handleDelete = async (id: string) => {
    setDeleteId(id);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      setLoading(true);
      dispatch(deleteSector(deleteId))

      setDeleteId(null);
      loadData(filters);
    }
  };

  const cancelDelete = () => {
    setDeleteId(null);
  };

  const columns: Column<SectorOutputDTO>[] = [
    {
          image:'photoUrl',
          // placeholderImage:'https://static.thenounproject.com/png/778835-200.png',
      key: 'name' as keyof SectorOutputDTO,
      header: 'Nome',
      render: (value: any) => String(value || ''),
    },
    // {
    //   key: 'createdAt' as keyof SectorOutputDTO,
    //   header: 'Data de Criação',
    //   render: (value: any) => value ? new Date(value as Date).toLocaleDateString() : '-',
    // },
  ];

  const filterFields = [
    {
      name: 'name',
      label: 'Nome',
      type: 'text',
    },
  ];

  if (loading && isInitialLoad) {
    return <LoadingSkeleton />;
  }

  if (error) {
    return <ErrorDisplay error={error} />;
  }

  return (
    <div className="flex flex-col flex-1 shrink  self-stretch px-6 py-7 basis-0 min-w-60 max-md:px-5 bg-background-dark">
      {/* <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Funções</h1>
        
      </div> */}
      
      {/* Temporarily commenting out DataFilter until we fix its interface */}
      {/* <DataFilter fields={filterFields} onFilterChange={handleFilterChange} /> */}
      
      <DataTable
        columns={columns}
        data={items}
        newFormat
        hide_show

        basePath="sectors"
        onDelete={handleDelete}
        title={'Setores'}
        loading={loading}
        error={error}
      />
      
      <Dialog open={!!deleteId} onClose={cancelDelete}>
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir esta função? Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancelar
          </Button>
          <Button onClick={confirmDelete} color="error">
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
      </div>
    
  );
};

export default SectorList; 